import React, { useMemo } from 'react';
import { connect } from 'umi';
import { isEqual } from 'lodash-es';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import useIntls from '@opm/hooks/useIntls';
import { TSecondOptionsItem, IMultipleCommonType } from '../../types';
import {
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
} from '../../connect/multiple';
import { CommonSelectButton } from '../../components/CommonSelectButton';
import './index.scss';

export type TLanguageSelectType = {
  options: TSecondOptionsItem[];
  valueKeys: string;
  title: string;
  titleCn: string;
};

interface LanguageMarketValue {
  type: 'market';
  regions: string[];
  markets: string[];
}

interface ILanguageSelectInnerProps
  extends TLanguageSelectType,
    Omit<IMultipleCommonType, 'value'> {
  filterValue: any;
  value?: LanguageMarketValue;
  onClose?: () => void;
}

const chinaRegion = ['chn', 'hmt'];

function LanguageSelect({
  value,
  change,
  onClose,
  options = [],
  title,
  titleCn,
}: ILanguageSelectInnerProps) {
  const { isEn } = useIntls();
  const locale = isEn ? 'en-US' : 'zh-CN';

  const twoLevelOptions = useMemo(() => {
    return options as any[];
  }, [options]);

  const buttonElement = (
    <CommonSelectButton
      value={value}
      options={twoLevelOptions}
      title={title}
      titleCn={titleCn}
    />
  );

  const shortcutOptions = useMemo(() => {
    return [
      {
        textCN: '全部',
        text: 'All',
        type: 'All',
        filter: (opts: any[]) => {
          const markets: string[] = [];
          (opts || []).forEach((region: any) => {
            (region.children || []).forEach((child: any) => {
              markets.push(child.value);
            });
          });
          return markets;
        },
      },
      {
        textCN: '非中国',
        text: 'non-Chinese',
        type: 'non-Chinese',
        filter: (opts: any[]) => {
          const markets: string[] = [];
          (opts || [])
            .filter((item: any) => !chinaRegion.includes(item.value))
            .forEach((region: any) => {
              (region.children || []).forEach((child: any) => {
                markets.push(child.value);
              });
            });
          return markets;
        },
      },
      {
        textCN: '中国',
        text: 'Chinese',
        type: 'Chinese',
        filter: (opts: any[]) => {
          const markets: string[] = [];
          (opts || [])
            .filter((item: any) => chinaRegion.includes(item.value))
            .forEach((region: any) => {
              (region.children || []).forEach((child: any) => {
                markets.push(child.value);
              });
            });
          return markets;
        },
      },
    ];
  }, []);

  const languageTitleLocal = useMemo(
    () => ({
      'zh-CN': {
        regionTitle: '地区',
        marketTitle: '语言',
      },
      'en-US': {
        regionTitle: 'Region',
        marketTitle: 'Language',
      },
    }),
    [],
  );

  return (
    <div className="dbom-language-select-wrapper">
      <NewRegionSelect
        value={value}
        options={twoLevelOptions}
        locale={locale}
        button={buttonElement}
        shortcutOptions={shortcutOptions}
        language={languageTitleLocal}
        closeOnScroll={true}
        onChange={(selectValue: any) => {
          // 判断是否和原值相同，相同则不改变
          const isSame = isEqual(selectValue, value);
          if (!isSame) {
            change(selectValue);
          }
        }}
        onCloseReginSelect={() => {
          onClose?.();
        }}
      />
    </div>
  );
}

export default connect(
  multipleMapStateToProps,
  moreKeyMultipleDispatchToProps,
)(LanguageSelect);
